import { LocaleDataIndex } from "@angular/common/src/i18n/locale_data";
import { GrupoClienteModel } from "./grupocliente.model";
import { IndiceReajusteModel } from "./indicereajuste.model";
import { RamoAtividadeModel } from "./ramoatividade.model";
import { TipoClienteModel } from "./tipocliente.model";
import { TipoReajusteModel } from "./tiporeajuste.model";


export class ClienteModel {
    id:number;
    status: boolean;
    nome: String;
    cpf: String;
    nomeFantasia: String;
    responsavel: String;
    email: String;
    inscricaoEstadual: String;
    inscricaoMunicipal: String;
    observacao: String;
    dataReajuste: LocaleDataIndex;
    tipoCliente: TipoClienteModel;
    ramoAtividade: RamoAtividadeModel;
    grupoCliente: GrupoClienteModel;
    indiceReajuste: IndiceReajusteModel;
    tipoReajuste: TipoReajusteModel;
}



// WEBPACK FOOTER //
// /app/src/app/model/cliente/cliente.model.ts